import { DrawerLabelProps } from "./types";
import React from "react";

export const DrawerLabel = ({
  icon: Icon,
  isOpen,
  isActive,
  title,
}: DrawerLabelProps): React.ReactElement => (
  <section
    className={`group relative w-full cursor-pointer rounded-sm py-[6.5px] px-[10.5px] hover:bg-[#818181] group-hover:bg-[#818181] ${
      isActive ? "bg-[#818181]" : ""
    }`}
  >
    <section className={`flex items-center ${isOpen ? "" : "justify-center"}`}>
      <Icon height={22} width={22} fill="white" />
      {isOpen ? (
        <span className="ml-[20px] truncate text-[16px] text-white">
          {title}
        </span>
      ) : null}
    </section>
    {!isOpen && (
      <section className="absolute top-0 left-full ml-2 hidden h-full items-center whitespace-nowrap rounded-sm bg-[#ffffff] px-4 py-1 text-[12px] font-bold text-black drop-shadow-lg group-hover:flex">
        {title}
      </section>
    )}
  </section>
);
